import React from 'react';
import styled from 'styled-components';

export const WashIcon = ({ id }) => {
  if (id === 'Washing1') return <IconDiv>&#x0028;</IconDiv>;
  if (id === 'Washing2') return <IconDiv>&#x002C;</IconDiv>;
  if (id === 'Washing3') return <IconDiv>&#x0034;</IconDiv>;
  if (id === 'Washing4') return <IconDiv>&#x00B5;</IconDiv>;
  if (id === 'Washing5') return <IconDiv>&#x0063;</IconDiv>;
  if (id === 'Washing6') return <IconDiv>&#x0064;</IconDiv>;
  if (id === 'Washing7') return <IconDiv>&#x0065;</IconDiv>;
  if (id === 'Washing8') return <IconDiv>&#x00AB;</IconDiv>;
  if (id === 'Washing9') return <IconDiv>&#x201E;</IconDiv>;
  if (id === 'Washing10') return <IconDiv>&#x00B6;</IconDiv>;
  if (id === 'Washing11') return <IconDiv>&#x0022;</IconDiv>;
  if (id === 'Washing12') return <IconDiv>&#x002A;</IconDiv>;
  if (id === 'Washing13') return <IconDiv>&#x0022;&#x002A;</IconDiv>;
  if (id === 'Washing14') return <IconDiv>&#x00C7;</IconDiv>;
  if (id === 'Washing15') return <IconDiv>&#x0026;</IconDiv>;
  return false;
};

const IconDiv = styled.span`
  color: black;
  font-size: 14px;
  font-family: WashingMachine;
  font-weight: normal;
  font-style: normal;
  line-height: 0;
`;



// WEBPACK FOOTER //
// ./src/components/WashIcon.js